import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';
import { Toolbar } from 'primereact/toolbar';
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import { Image } from 'primereact/image';

import { InOutRegisterTabs } from '../InOutRegisterTabs';
import { CertificateShowClick, OutwardRegistar } from '../../../config/Validate';
import { defaultPageRowOptions, defaultRowOptions, inOutMainType, SkeletonbodyTemplate, Skeletonitems } from '../../../appconfig/Settings';
import moment from 'moment';
import { deleteDataWithParameters, getAllDetails, getAllDetailsDirect, postAllData } from '../../../service/ProductService';
import { ADD_OUTWARD, DELETE_IN_OUT, GET_OUTWARD_LIST, GLOBALVAL } from '../../../config/ApiConstant';
import { Calendar } from 'primereact/calendar';
import { formatYearMonthDate } from '../../../appconfig/AppHelper';
import { AddOutwardRegisterListColumns } from '../../../appconfig/DatatableSetting';
import { EntDtTemplate } from '../../../appconfig/DatatableTemplateSetting';
import CustomDatePicker from '../../../components/CustomDatePicker/CustomDatePicker';

export const OutwardRegister = () => {
    document.title = 'Add Outward Registration | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    const navigate = useNavigate();

    // Date Object

    const storedDates = localStorage.getItem('addOut_app');
    let initialStartDate = moment().subtract(30, 'days').toDate();
    let initialEndDate = moment().toDate();

    if (storedDates) {
        try {
            const parsed = JSON.parse(storedDates);
            initialStartDate = parsed.startDate ? new Date(parsed.startDate) : initialStartDate;
            initialEndDate = parsed.endDate ? new Date(parsed.endDate) : initialEndDate;
        } catch (error) {
            console.error('Error parsing stored dates', error);
        }
    }

    const [dates, setDates] = useState({
        start: initialStartDate,
        end: initialEndDate
    });

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [errors, setErrors] = useState<any>({});
    const [regNo, setRegNo] = useState<any>('');
    const [outwardData, setOutwardData] = useState<any>({
        EntDt: new Date(),
        Amt: 0,
    });
    const [addLoader, setAddLoader] = useState<boolean>(false);
    const [outwardList, setOutwardList] = useState<any>([]);
    const [subType, setSubType] = useState<any>([]);
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [deleteId, setDeleteId] = useState<any>(null);
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [deleteLoader, setDeleteLoader] = useState<boolean>(false);
    const [editId, setEditId] = useState(null);

    // useEffect
    useEffect(() => {
        getAllOutwardList();
    }, [dates]);

    // useEffect
    useEffect(() => {
        getSubType();
    }, []);

    // On Date Change
    const onDateChange = (start: any, end: any) => {
        setDates({ start, end });

        if (start && end) {
            localStorage.setItem(
                'addOut_app',
                JSON.stringify({
                    startDate: moment(start).format('YYYY-MM-DD'),
                    endDate: moment(end).format('YYYY-MM-DD')
                })
            );
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                {/* <span className="search-bar mr-3">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span> */}
                <CustomDatePicker startDate={dates?.start} endDate={dates?.end} onChange={onDateChange} />
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined"></Button>
            </>
        );
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
    };

    // Get sub type
    const getSubType = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetails(GLOBALVAL + '?DataCode=outward');
            if (response) {
                const subTypeData: any = [];
                for (let i = 0; i < response.length; i++) {
                    const subTypeObj: any = {};

                    subTypeObj['name'] = response[i].Data;
                    subTypeObj['code'] = response[i].SrNo;
                    subTypeData.push(subTypeObj);
                }
                setPageLoad(true);
                setSubType(subTypeData);
            }
        } catch (error: any) {
            setPageLoad(false);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Get all Outward list
    const getAllOutwardList = async () => {
        try {
            setPageLoad(false);
            let startDate = moment(dates?.start).format('y-M-D') + ' 00:00:00';
            let endDate = moment(dates?.end).format('y-M-D') + ' 23:59:59';
            const response = await getAllDetailsDirect(GET_OUTWARD_LIST + '?start_date=' + startDate + '&end_date=' + endDate);
            if (response) {
                setPageLoad(true);
                setOutwardList(response.list);
            }
        } catch (error: any) {
            setPageLoad(false);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Clear all
    const clearAll = () => {
        const selectedTypeMain = outwardData?.TypeNo;
        const selectedTypeSub = outwardData?.IOType;
        setRegNo('');
        setOutwardData({
            EntDt: new Date()
        });
        setEditId(null);
        setOutwardData((prev: any) => ({
            ToNm: '',
            Sub: '',
            TypeNo: selectedTypeMain || null,
            IOType: selectedTypeSub || null,
            Note1: '',
            ToAddress: '',
            Amt: 0,
            EntDt: new Date()
        }));
        setErrors({});
    };

    // On show click
    const onShowClick = async () => {
        try {
            const { errors, isError } = CertificateShowClick(regNo);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setShowLoading(true);

                const response = await getAllDetailsDirect(GET_OUTWARD_LIST + '?RegNo=' + regNo);

                if (!window.cn(response) && Object.keys(response.details).length !== 0) {
                    const { StudF, StudM, StudL, PAddress, PPIN, SrNo, Image, user } = response.details[0];
                    let ToNm = (!window.cn(StudL) ? StudL : '') + ' ' + (!window.cn(StudF) ? StudF : '') + ' ' + (!window.cn(StudM) ? StudM : '');
                    let ToAddress = PAddress.replace(/[,\s]+$/, "") + (!window.cn(PPIN) ? "-" + PPIN : '');
                    let FileNo = SrNo;
                    let mobile = user ? user?.mobile : ''
                    setOutwardData((prev: any) => ({
                        ...prev,
                        ToNm: ToNm,
                        ToAddress: ToAddress,
                        FileNo: FileNo,
                        Image: Image,
                        mobile: mobile
                    }));
                    setShowLoading(false);
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast

                setShowLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    //onchange event
    const onInputChange = (e: any, name: string) => {
        let val;
        if (name === 'TypeNo' || name === 'IOType' || name === 'EntDt') {
            val = e;
        } else {
            val = (e.target && e.target.value) || e.value || '';
        }
        setOutwardData({ ...outwardData, [name]: val });
    };

    // Add Outward data
    const addOutwardData = async () => {
        try {
            const { errors, isError } = OutwardRegistar(outwardData);
            setErrors(errors);
            //Check Error if no errors then call API
            if (!isError) {
                setAddLoader(true);

                let formData: any = new FormData();
                formData.append('RegNo', regNo);
                formData.append('FromNm', 'GSPC');
                formData.append('TypeNm', 'outward');
                formData.append('IOType', Number(outwardData.IOType.code));
                formData.append('TypeNo', outwardData.TypeNo.code);
                formData.append('EntDt', formatYearMonthDate(outwardData.EntDt));
                formData.append('ToNm', outwardData.ToNm);
                formData.append('Sub', outwardData.Sub);
                formData.append('Note1', outwardData.Note1);
                formData.append('ToAddress', outwardData.ToAddress);
                formData.append('mobile', outwardData.mobile);
                formData.append('Amt', outwardData.Amt ?? 0);
                if (!window.cn(editId)) {
                    formData.append('id', editId);
                }

                const response = await postAllData(ADD_OUTWARD, formData);
                if (response) {
                    setAddLoader(false);
                    toast.current?.show({ severity: 'success', summary: 'Message', detail: response?.data });
                    clearAll();
                    getAllOutwardList();
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setAddLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // Template for ToAddress
    const ToAddressTemplate = (rowData: any, rowIndex: any) => {
        return (
            <>
                <Button tooltip={rowData?.ToAddress} className="p-button-custom-tooltip" tooltipOptions={{ position: 'top' }}>
                    <div className="college-name-div">{!window.cn(rowData.ToAddress) ? rowData.ToAddress : ''}</div>
                </Button>
            </>
        );
    };

    // Template for main_type
    const MainTypeTemplate = (rowData: any) => {
        return <>{rowData?.main_type?.Data}</>;
    };

    // Template for actions
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <div className="actions action-btn">
                    <Button tooltip="Edit" tooltipOptions={{ position: 'top' }} icon="pi pi-pencil" onClick={() => editOutward(rowData)} />
                    <Button className="p-button-danger ml-2" tooltip="Delete" tooltipOptions={{ position: 'top' }} icon="pi pi-trash" onClick={() => openDeleteModal(rowData.id)} />
                </div>
            </>
        );
    };

    //editOutward
    const editOutward = (rowData: any) => {
        const { ToNm, Sub, main_type, sub_type, Note1, ToAddress, EntDt, Amt, RegNo } = rowData;
        let mainTypeObj = inOutMainType.find((item) => item.code === main_type?.SrNo);
        let subTypeObj = {
            name: sub_type?.Data,
            code: sub_type?.SrNo
        };
        setRegNo(RegNo);
        setEditId(rowData?.id);
        setOutwardData({
            ToNm: ToNm,
            Sub: Sub,
            TypeNo: mainTypeObj,
            IOType: subTypeObj,
            Note1: Note1,
            ToAddress: ToAddress,
            Amt: Amt,
            EntDt: new Date(EntDt)
        });
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    // Open delete modal
    const openDeleteModal = (id: any) => {
        setDeleteId(id);
        setDeleteModal(true);
    };

    // Close delete modal
    const closeDeleteModal = () => {
        setDeleteId(null);
        setDeleteLoader(false);
        setDeleteModal(false);
    };

    // Delete Outward data
    const deleteOutwardData = async () => {
        try {
            setDeleteLoader(true);

            //apicall
            const response = await deleteDataWithParameters(DELETE_IN_OUT + '/' + deleteId);
            if (response && !window.cn(response)) {
                setDeleteId(null);
                setDeleteLoader(false);
                setDeleteModal(false);
                toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.data });
                setTimeout(() => {
                    getAllOutwardList();
                }, 1500);
            }
        } catch (error: any) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Something Went Wrong'
            });
        }
    };

    return (
        <>
            <InOutRegisterTabs mainTabLabel="OutWard Register" />
            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <div className="p-fluid formgrid grid align-items-center">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="regNo">
                                    Reg/File No <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText value={regNo} name="regNo" autoComplete="off" placeholder="Enter Reg No." onChange={(e) => setRegNo(e.target.value)} className={errors['regNo'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['regNo']}</small>
                            </div>
                            <div className="field col-12 md:col-1 mt-4">
                                <Button label="Show" className="p-button-primary" onClick={() => onShowClick()} loading={showLoading} />
                            </div>
                            <div className="field col-12 md:col-5">
                                {!window.cn(outwardData?.Image) ? (
                                    <Image style={{ float: 'right', border: ' 1px solid #333' }} src={outwardData?.Image} alt="Image" width="100" preview />
                                ) : (
                                    <Image style={{ float: 'right', border: ' 1px solid #333' }} src="/assets/images/avatar.png" alt="Image" width="100" />
                                )}
                            </div>
                            <div className="field col-12 md:col-2 mb-0">
                                <Button label="Outward List" className="p-button-primary p-button-outlined" onClick={() => navigate('/app/in-out/outward-registration-list')} />
                            </div>
                        </div>
                        <hr />
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="FromNm">
                                    From <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText value={'GSPC'} name="FromNm" disabled={true} />
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="ToNm">
                                    To <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText value={outwardData?.ToNm} name="ToNm" autoComplete="off" placeholder="Enter To" onChange={(e) => onInputChange(e, 'ToNm')} className={errors['ToNm'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['ToNm']}</small>
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="Sub">
                                    Subject <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText value={outwardData?.Sub} name="Sub" autoComplete="off" placeholder="Enter Subject" onChange={(e) => onInputChange(e, 'Sub')} className={errors['Sub'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['Sub']}</small>
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="TypeNo">
                                    Type Main <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Dropdown
                                    value={outwardData?.TypeNo}
                                    name="TypeNo"
                                    options={inOutMainType}
                                    filter
                                    optionLabel="name"
                                    placeholder="Select Type"
                                    onChange={(e) => onInputChange(e.value, 'TypeNo')}
                                    className={errors['TypeNo'] && 'p-invalid'}
                                />
                                <small className="p-invalid-txt">{errors['TypeNo']}</small>
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="IOType">
                                    Type Sub Type <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Dropdown
                                    value={outwardData?.IOType}
                                    name="IOType"
                                    options={subType}
                                    filter
                                    optionLabel="name"
                                    placeholder="Select Sub Type"
                                    onChange={(e) => onInputChange(e.value, 'IOType')}
                                    className={errors['IOType'] && 'p-invalid'}
                                />
                                <small className="p-invalid-txt">{errors['TypeNo']}</small>
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="Note1">
                                    Note <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText value={outwardData?.Note1} name="Note1" autoComplete="off" placeholder="Enter Note" onChange={(e) => onInputChange(e, 'Note1')} className={errors['Note1'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['Note1']}</small>
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="ToAddress">
                                    Address <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputTextarea rows={5} cols={30} value={outwardData?.ToAddress} name="ToAddress" onChange={(e) => onInputChange(e, 'ToAddress')} className={errors['ToAddress'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['ToAddress']}</small>
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="mobile">
                                    Mobile <span style={{ color: 'red' }}></span>
                                </label>
                                <InputText value={outwardData?.mobile} name="mobile" autoComplete="off" placeholder="Enter Mobile No" onChange={(e) => onInputChange(e, 'mobile')} className={errors['mobile'] && 'p-invalid'} />
                                {/* <small className="p-invalid-txt">{errors['mobile']}</small> */}
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="Amt">Amount</label>
                                <InputNumber value={outwardData?.Amt ?? 0} name="Amt" useGrouping={false} placeholder="Enter Amount" onChange={(e) => onInputChange(e, 'Amt')} className={errors['Amt'] && 'p-invalid'} />
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="EntDt">
                                    Date <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Calendar value={outwardData?.EntDt} dateFormat="dd-mm-yy" onChange={(e: any) => onInputChange(e.value, 'EntDt')} showIcon className={errors['EntDt'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['EntDt']}</small>
                            </div>
                        </div>
                        <div className="formgrid grid">
                            <div className="field col-12 md:col-12">
                                <div style={{ display: 'flex', float: 'right', gap: 4 }}>
                                    <Button label="Clear" icon="pi pi-times" className="p-button-secondary mr-2" onClick={() => clearAll()} />
                                    <Button label={!window.cn(editId) ? 'Edit' : 'Add'} icon="pi pi-plus" onClick={() => addOutwardData()} loading={addLoader} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={outwardList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={outwardList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Outward Found"
                                >
                                    {AddOutwardRegisterListColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'EntDt') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={EntDtTemplate} />;
                                        } else if (col.field === 'ToAddress') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={ToAddressTemplate} />;
                                        } else if (col.field === 'main_type') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={MainTypeTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {AddOutwardRegisterListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Delete Dialog */}
            <Dialog
                visible={deleteModal}
                style={{ width: '450px' }}
                header="Delete Outward"
                modal
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeDeleteModal} />
                        <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={deleteOutwardData} loading={deleteLoader} />
                    </>
                }
                onHide={closeDeleteModal}
            >
                <div className="flex align-items-center justify-content-start">
                    <i className="pi pi-exclamation-triangle mr-3 delete-triangle" style={{ fontSize: '2rem' }} />
                    <span className="delete-dialog-note">Note: Once you delete this Outward, This will be deleted permentatly.</span>
                </div>
            </Dialog>
        </>
    );
};
